<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Reportes</label>
              <v-select :options="arr.filters.reports" v-model="filters.report" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Staff</label>
              <v-select :options="arr.filters.staff" v-model="filters.staff" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filter()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card>
        <b-table class="app-table reports-log-table"
                 responsive
                 :stacked="isMobileViewport ? 'md' : false"
                 sticky-header="60vh"
                 :hover="true"
                 :small="true"
                 :fixed="true"
                 :items="table.items"
                 :fields="table.fields"
                 :current-page="table.currentPage"
                 :per-page="table.perPage"
                 :busy="table.isBusy"
                 v-if="table.items.length || table.isBusy">

            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
              >
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>

            <template v-slot:cell(id)="data">
              <strong>{{data.item.id}}</strong>
            </template>

            <template v-slot:cell(date)="data">
              {{moment(data.item.date).format('DD/MM/YYYY HH:mm')}}
            </template>

            <template v-slot:cell(title)="data">
              <strong>{{data.item.title}}</strong>
            </template>

            <template v-slot:cell(staff_id)="data">
              {{data.item.staff.name}}
            </template>

            <template v-slot:cell(metadata)="data">
              <div v-if="data.item.metadata">
                <b-badge v-for="(element, index) in data.item.metadata.split('|')"
                         :key="index" href="javascript:void(0);"
                         variant="light"
                         class="ml-1"
                         style="font-size:12px;">
                  {{element}}
                </b-badge>
              </div>
            </template>

            <template v-slot:cell(f_action)="data">
              <b-dropdown right
                          no-caret
                          size="sm"
                          variant="link"
                          boundary="window"
                          :toggle-class="isMobileViewport ? 'reports-log-action-toggle-labeled' : 'app-table-action-toggle'"
                          :class="{ 'pull-right': !isMobileViewport }">
                <template #button-content>
                  <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                  <span v-if="isMobileViewport">Opciones</span>
                </template>
                <b-dropdown-item @click="sendPrinter(data.item)">
                  <AppIcon name="print" /> Imprimir
                </b-dropdown-item>
              </b-dropdown>
            </template>
        </b-table>
        <EmptyState v-else title="No se encontraron registros" />

        <div class="app-table-footer" v-if="table.tablePaginate">
          <span class="list-view-toolbar__count">{{ table.tablePaginate.total }} registros</span>
        </div>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="chevron-double-left" class="mr-1" />Volver
          </b-button>

          <nav v-if="table.tablePaginate">
            <b-pagination class="mb-0"
                          size="sm"
                          pills=""
                          :total-rows="table.tablePaginate.total"
                          :per-page="table.tablePaginate.per_page"
                          v-model="table.currentPage"
                          @input="filter()" />
          </nav>
        </div>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.pdf"
              :pdf="crud.print.pdf"
              :key="crud.print.key"/>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import moment from 'moment'
  import Printer from '@/components/inc/printer/printer'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import StorageLocal from '@/handler/storageLocal'

  export default {
    components: {
      FindObject,
      Printer,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.REPORTES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'log',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        crud: {
          print: {
            pdf: '',
            key: 0,
          }
        },
        arr: {
          filters: {
            staff: [],
            reports: [],
          }
        },
        filters: {
          date_start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          staff: '',
          report: '',
        },
        // Panel de filtros: cerrado por default; el usuario que lo abre
        // queda con su preferencia persistida (ver watcher filtersOpen).
        filtersOpen: false,
        // stacked (modo card mobile) y sticky-header son mutuamente
        // excluyentes en BootstrapVue (hasStickyHeader = !isStacked && ...,
        // ver td.js/tbody.js) — pasar "md" fijo mataba el sticky-header
        // también en desktop. Por eso stacked se activa solo cuando el
        // viewport realmente está en mobile (ver mounted/mobileMql).
        isMobileViewport: false,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_reports_log') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.filterLoad()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_reports_log', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), el label
      // del campo de acciones tiene que recalcularse (ver loadFieldTable).
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      // Alineación de columna: en mobile (modo stacked) el valor pasa a
      // apilarse debajo de su label, así que la alineación de columna de
      // desktop no tiene sentido — se resuelve acá, en el propio JSON de
      // fields, en vez de pelear contra la clase con CSS.
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', class: 'align-middle', width: '5%'},
          {key: 'date', label: 'Fecha', class: 'align-middle text-left', width: '10%'},
          {key: 'staff_id', label: 'Staff', class: 'align-middle text-left', width: '15%'},
          {key: 'title', label: 'Nombre', class: 'align-middle text-left', width: '15%'},
          {key: 'metadata', label: 'Detalle', class: 'align-middle text-left', width: '50%'},
          // Tabla sin drawer de detalle: el kebab se conserva en mobile
          // (ver docs/list-view-interfaces "ABM sin drawer: acción retenida
          // en mobile"), por eso lleva label real solo en ese ancho.
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width: '5%'},
        ]
      },
      filterLoad() {
        this.filterLoadStaff()
        this.filterLoadReports()
      },
      filterLoadStaff() {
        var result = serviceAPI.obtenerStaff()
        result.then((response) => {
          var data = response.data

          this.arr.filters.staff = []
          data.forEach(element => {
            if(element.id == Helper.getStaffId()) {
              this.filters.staff = { code: element.id, label: element.name }
            }
            this.arr.filters.staff.push({ code: element.id, label: element.name })
          });

          this.filter()
        })
      },
      filterLoadReports() {
        var result = serviceAPI.obtenerReports()
        result.then((response) => {
          var data = response.data

          this.arr.filters.reports = []
          data.forEach(element => {
            this.arr.filters.reports.push({ code: element.id, label: element.name })
          });
        })
      },
      filter() {
        this.table.isBusy = true
        var result = serviceAPI.getFilterReportLog(this.filters, this.table.currentPage)

        result.then((response) => {
          var data = response.data
          this.table.items = data.data
          this.table.tablePaginate = data

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },

      sendPrinter(item) {
        this.crud.print.key = Math.random()
        this.crud.print.pdf = item.url
      }
    }
  }
</script>
<style>
  .btn.reports-log-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.reports-log-action-toggle-labeled:hover,
  .btn.reports-log-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .reports-log-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
